import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { login } from './Pages/LoginPage/loginSlice';
import TokenService from '../../services/token.service';
import { AuthorizationResponseType } from '../../types/auth';
import { confirmCode } from './Pages/SignUpPage/Steps/Confirm/signupConfirmSlice';
import { confirmInvite } from './Pages/SignUpByInvitePage/signUpByInviteSlice';
import { updateHeaderAuthorizationToken } from '../../common/http';

interface OnboardingState {
  pending: boolean;
  loggedOut: boolean;
}

const setTokens = (state: OnboardingState, action: PayloadAction<AuthorizationResponseType>) => {
  const { accessToken, refreshToken } = action.payload;
  TokenService.updateLocalAccessToken(accessToken);
  TokenService.updateLocalRefreshToken(refreshToken);
  state.loggedOut = false;
  state.pending = false;
  updateHeaderAuthorizationToken(accessToken);
};

const initialState: OnboardingState = {
  pending: false,
  loggedOut: false,
};
export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: state => {
      state.loggedOut = true;
      TokenService.flush();
      updateHeaderAuthorizationToken('');
    },
  },
  extraReducers: builder => {
    builder.addCase(login.fulfilled, setTokens);
    builder.addCase(login.pending, state => {
      state.pending = true;
    });
    builder.addCase(login.rejected, state => {
      state.pending = false;
      state.loggedOut = true;
    });
    builder.addCase(confirmCode.fulfilled, setTokens);
    builder.addCase(confirmInvite.fulfilled, setTokens);
  },
});

export const { logout } = authSlice.actions;

export default authSlice.reducer;
